export default {
	key: 'allowMultipleMasks',
	ignore: true
};
